import { bootstrapApplication } from '@angular/platform-browser';
import { provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideIonicAngular } from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import {
  analyticsOutline, albumsOutline, arrowForwardOutline, calendarOutline,
  cameraOutline, checkmarkCircleOutline, chevronBackOutline, cloudDoneOutline,
  cloudOfflineOutline, documentTextOutline, folderOpenOutline, gridOutline,
  leafOutline, logOutOutline, mapOutline, menuOutline, refreshOutline,
  searchOutline, shieldCheckmarkOutline, waterOutline, closeOutline,
  barChartOutline, downloadOutline, funnelOutline, peopleOutline, locationOutline,
  listOutline, earthOutline, fileTrayOutline, chevronForwardOutline, mailOutline,
  addOutline, addCircleOutline, createOutline, saveOutline, locateOutline, personOutline
} from 'ionicons/icons';
import { AppComponent } from './app/app.component';
import { routes } from './app/app.routes';

addIcons({
  analyticsOutline, albumsOutline, arrowForwardOutline, calendarOutline,
  cameraOutline, checkmarkCircleOutline, chevronBackOutline, cloudDoneOutline,
  cloudOfflineOutline, documentTextOutline, folderOpenOutline, gridOutline,
  leafOutline, logOutOutline, mapOutline, menuOutline, refreshOutline,
  searchOutline, shieldCheckmarkOutline, waterOutline, closeOutline,
  barChartOutline, downloadOutline, funnelOutline, peopleOutline, locationOutline,
  listOutline, earthOutline, fileTrayOutline, chevronForwardOutline, mailOutline,
  addOutline, addCircleOutline, createOutline, saveOutline, locateOutline, personOutline
});
bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideIonicAngular()
  ]
}).catch((error: unknown) => console.error('No se pudo iniciar la aplicación:', error));
